import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import moment from "moment";
import api from "../../../apis/api";
import Select from 'react-select';
import "../../../style/Holidaychanges.css";


const HolidaycalendarDetails = ({ holidayCalendar = [] }) => {
  const [holidayList, setHolidayList] = useState([]);
  const [yearslist, setYearslist] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#0f9d8a',
      color: 'white',
      borderColor: state.isFocused ? '#0f9d8a' : '#ccc',
      width: '120px',
      fontWeight: '600',
      borderRadius: '0.25rem',
      borderwidth: '2px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white',
    }),
    input: (provided) => ({
    ...provided,
    color: 'white', // 👈 fixes black text when focused
  }),
    dropdownIndicator: (provided, state) => ({
    ...provided,
    color: 'white',
    transition: 'transform 0.2s ease',
    transform: state.selectProps.menuIsOpen
      ? 'rotate(180deg)'
      : 'rotate(0deg)', // 👈 visual dropdown indicator
    '&:hover': {
      color: 'white !important',
    },
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#0f9d8a' : state.isFocused ? '#0f9d8a' : 'white',
      color: state.isSelected ? 'white' : 'black',
      
    // 👇 THIS removes the blue blink
    ':active': {
      backgroundColor: '#0f9d8a',
    },
    }),
  };

  const yearOptions = yearslist.map(y => ({ value: y.year, label: y.year }));

  useEffect(() => {
    if (Array.isArray(holidayCalendar)) {
      setHolidayList(holidayCalendar);
    }
  }, [holidayCalendar]);

  useEffect(() => {
    const fetchYears = async () => {
      const res = await api.dbcalendar().GeYearFromtHolidayCalendarList();
      setYearslist(res.data);
      setYear(res.data[res.data.length - 1]?.year);
    };
    fetchYears();
  }, []);

  return (
    <div className="hc-wrapper">
      {/* HEADER */}
      <div className="hc-header">
        <div className="hc-title">Holiday Calendar {year}</div>
        <Select
          options={yearOptions}
          value={yearOptions.find(option => option.value == year)}
          onChange={(selectedOption) => setYear(selectedOption.value)}
          styles={customStyles}
          placeholder="Select Year" 
          isSearchable={false}
          menuPortalTarget={document.body}

        />
      </div>

      {/* MONTH GRID */}
      <div className="hc-grid">
        {Array.from({ length: 12 }).map((_, m) => {
          const monthName = moment().month(m).format("MMMM");

          const data = holidayList.filter(
            (h) =>
              h.holidayDate &&
              moment(h.holidayDate).month() === m &&
              moment(h.holidayDate).year() == year
          );

          return (
            <div key={m} className="hc-card" style={{ minHeight: '200px' }}>
              <div className="hc-month">{monthName} {year}</div>

              {data.length > 0 ? (
  data.map((h, i) => (
    <div key={i} className="hc-row">
      <div className="hc-name">
        {moment(h.holidayDate).format("DD")} - {h.title}
      </div>
      <div className="hc-day">
        {moment(h.holidayDate).format("dddd")}
      </div>
    </div>
  ))
) : (
  <div className="hc-no-data" style={{fontWeight:600}}>
    No holidays this month
  </div>
)}

            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HolidaycalendarDetails;
